import React, { FC } from 'react';

import { IUser } from 'types';
import Button from 'components/Button/Button';
import { ReactComponent as UserIcon } from 'icons/user_icon.svg';
import styles from './ProfileAgreement.module.scss';

interface Props {
  onOk: () => void;
  onCancel: () => void;
  profile: IUser;
}

export const ProfileAgreement: FC<Props> = ({ profile, onOk, onCancel }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.userInfo}>
        <UserIcon className={styles.avatar} aria-hidden="true" />
        <div className={styles.name}>
          {[profile.firstName, profile.middleName, profile.lastName ? profile.lastName.slice(0, 1) + '.' : null]
            .filter(Boolean)
            .join(' ')}
        </div>
      </div>
      <div className={styles.footer}>
        <Button onClick={onCancel} type="outline">Это не я</Button>
        <Button onClick={onOk}>Далее</Button>
      </div>
    </div>
  );
};
